
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import StageBaseController from '../stage-base.controller';

export default class ImaginacaoController extends StageBaseController {
	constructor($log, $state, $timeout, $interval, Dialog, Session) {
		'ngInject';
		super($log, $state, $timeout, $interval, Dialog, Session, 1);
		this.Session = Session;
		
		this.title="<span class='level'>Nível 1</span> <br/> Arraste as figuras e monte um desenho";
		this.level = Session.get().stages[this.stage].levels;
	}

	$onInit(){
		this.lodash_version = _.VERSION;
		this.startGame();
	}

	$onDestroy(){
		this.resetStage();
	}

	endGame(){
		this.$timeout(() => {
			this.Session.countLevel(null, this.stage, true); // timer, stage, forceComplete
			this.Dialog.showFeedback(null, super.stage, super.redirectToStages.bind(this), null, '');
		}, 1000)
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/imaginacao/imaginacao.controller.js